export default __webpack_public_path__ + "static/media/servicenow-long.0376af02.png";